/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetDefaultFacilityPhysician200ResponseDataPhysicianId
 */
export interface SetDefaultFacilityPhysician200ResponseDataPhysicianId {
}

/**
 * Check if a given object implements the SetDefaultFacilityPhysician200ResponseDataPhysicianId interface.
 */
export function instanceOfSetDefaultFacilityPhysician200ResponseDataPhysicianId(value: object): value is SetDefaultFacilityPhysician200ResponseDataPhysicianId {
    return true;
}

export function SetDefaultFacilityPhysician200ResponseDataPhysicianIdFromJSON(json: any): SetDefaultFacilityPhysician200ResponseDataPhysicianId {
    return SetDefaultFacilityPhysician200ResponseDataPhysicianIdFromJSONTyped(json, false);
}

export function SetDefaultFacilityPhysician200ResponseDataPhysicianIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultFacilityPhysician200ResponseDataPhysicianId {
    return json;
}

export function SetDefaultFacilityPhysician200ResponseDataPhysicianIdToJSON(json: any): SetDefaultFacilityPhysician200ResponseDataPhysicianId {
    return SetDefaultFacilityPhysician200ResponseDataPhysicianIdToJSONTyped(json, false);
}

export function SetDefaultFacilityPhysician200ResponseDataPhysicianIdToJSONTyped(value?: SetDefaultFacilityPhysician200ResponseDataPhysicianId | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

